import { type FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router";
import { confirmPassword, forgotPassword } from "../auth/CognitoClient";

export const Forgot = () => {
  const [stage, setStage] = useState<"request" | "confirm">("request");
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const request = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await forgotPassword(email.trim());
      setStage("confirm");
    } catch (err) {
      setError(err instanceof Error ? err.message : "request failed");
    } finally {
      setBusy(false);
    }
  };

  const reset = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await confirmPassword(email.trim(), code.trim(), password);
      nav("/login", { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : "reset failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <h1 className="h1">Reset password</h1>
        {stage === "request" ? (
          <form className="col gap-16" onSubmit={request}>
            <label className="field">
              Email
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </label>
            {error && <div className="error">{error}</div>}
            <button className="btn" type="submit" disabled={busy}>
              {busy ? "Sending…" : "Send code"}
            </button>
          </form>
        ) : (
          <form className="col gap-16" onSubmit={reset}>
            <label className="field">
              Code
              <input value={code} onChange={(e) => setCode(e.target.value)} />
            </label>
            <label className="field">
              New password
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                minLength={8}
              />
            </label>
            {error && <div className="error">{error}</div>}
            <button className="btn" type="submit" disabled={busy}>
              {busy ? "Resetting…" : "Reset password"}
            </button>
          </form>
        )}
        <div className="muted" style={{ marginTop: 12, textAlign: "center" }}>
          <Link to="/login">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
};
